import SessionRefresh from '../components/session-refresh.vue'

const SessionRefreshModal = {
    install(Vue) {
        // We must create new Eventbus
        // which is just another Vue instance that will be listening for and emiting events from our main instance 
        // this EventBus will be available as Modal.EventBus
        this.EventBus = new Vue()
        
        // making our modal component global
        Vue.component('session-refresh-modal', SessionRefresh)

        // exposing global $modal object with method show()
        // method show() takes object params as argument
        // inside this object we can have modal title, text, styles... and also our callback confirm function
        Vue.prototype.$sessionRefreshModal = {
            show(params) {
            // if we use this.$modal.show(params) inside our original Vue instance
            // we will emit 'show' event with parameters 'params'
            SessionRefreshModal.EventBus.$emit('show', params)
            }
        }
    }
}

export default SessionRefreshModal